// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { append, insertItem, patch, updateItem } from '@ngxs/store/operators';
import { PROGRESS_STATUSES } from 'symbols';
import { TalonsService } from '../../services/talons.service';
import { CreatedTalonByWS, UpdatedTalonByWS } from '../talon-manage/talon-manage.actions';
import {
  ClearScrollPositionTalonList,
  GetTalonList,
  GetTalonListError,
  GetTalonListSuccess,
  SetLastOpenedTalonId,
  UpdateScrollPositionTalonList
} from './talon-list.actions';
import { TALON_LIST_STATE_DEFAULT, TalonListStateModel } from './talon-list.model';

@State({ name: 'TalonList', defaults: TALON_LIST_STATE_DEFAULT })
@Injectable()
export class TalonListState {

  @Selector()
  static talonList(state: TalonListStateModel): TalonListStateModel['talonList'] {
    return state.talonList;
  }

  @Selector()
  static loadTalonListStatus(state: TalonListStateModel): TalonListStateModel['loadTalonListStatus'] {
    return state.loadTalonListStatus;
  }

  @Selector()
  static lastOpenedDocId(state: TalonListStateModel): TalonListStateModel['lastOpenedDocId'] {
    return state.lastOpenedDocId;
  }

  @Selector()
  static scrollPosition(state: TalonListStateModel): TalonListStateModel['scrollPosition'] {
    return state.scrollPosition;
  }

  constructor(private talonsService: TalonsService) {
  }

  @Action(GetTalonList)
  getTalonList(ctx: StateContext<TalonListStateModel>, { filter, lazy }: GetTalonList): void {
    if (lazy) {
      const next = ctx.getState().talonList?.links?.next;
      if (next) {
        ctx.patchState({
          loadTalonListStatus: PROGRESS_STATUSES.IN_PROGRESS
        });
        this.talonsService.getTalonListLazy(next).subscribe({
          next: res => ctx.dispatch(new GetTalonListSuccess(res, lazy)),
          error: error => ctx.dispatch(new GetTalonListError(error))
        });
      }
    } else {
      ctx.patchState({
        loadTalonListStatus: PROGRESS_STATUSES.IN_PROGRESS
      });
      this.talonsService.getTalonList(filter).subscribe({
        next: res => ctx.dispatch(new GetTalonListSuccess(res, lazy)),
        error: error => ctx.dispatch(new GetTalonListError(error))
      });
    }
  }

  @Action(GetTalonListSuccess)
  getTalonListSuccess(ctx: StateContext<TalonListStateModel>, { talonList, lazy }: GetTalonListSuccess): void {
    ctx.patchState({
      loadTalonListStatus: PROGRESS_STATUSES.SUCCESS
    });
    if (lazy) {
      ctx.setState(patch({
        talonList: patch({
          data: append([...talonList.data]),
          links: talonList.links,
          meta: talonList.meta
        })
      }));
    } else {
      ctx.patchState({
        talonList
      });

    }
  }

  @Action(GetTalonListError)
  getTalonListError(ctx: StateContext<TalonListStateModel>, { error }: GetTalonListError): void {
    ctx.patchState({
      loadTalonListStatus: PROGRESS_STATUSES.FAIL
    });
  }


  @Action(ClearScrollPositionTalonList)
  clearScrollPositionTalonList(ctx: StateContext<TalonListStateModel>): void {
    ctx.patchState({ scrollPosition: 0 });
  }

  @Action(UpdateScrollPositionTalonList)
  updateScrollPosition(ctx: StateContext<TalonListStateModel>, { position }: UpdateScrollPositionTalonList): void {
    ctx.patchState({ scrollPosition: position });
  }

  @Action(SetLastOpenedTalonId)
  setLastOpenedDocId(ctx: StateContext<TalonListStateModel>, { talonId }: SetLastOpenedTalonId): void {
    ctx.patchState({ lastOpenedDocId: talonId });
  }


  @Action(UpdatedTalonByWS)
  updatedOrderBuWS(ctx: StateContext<TalonListStateModel>, { talon }: UpdatedTalonByWS): void {

    ctx.setState(patch({
      talonList: patch({
        data: updateItem(o => o?.id === talon.id, talon)
      })
    }));
  }

  @Action(CreatedTalonByWS)
  createdOrderByWS(ctx: StateContext<TalonListStateModel>, { talon }: CreatedTalonByWS): void {
    ctx.setState(patch({
      talonList: patch({
        data: insertItem(talon, 0),
        meta: patch({
          totalItems: ctx.getState().talonList?.meta?.totalItems + 1
        })
      })
    }));

  }
}


